"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const node_1 = require("../node");
const signature_1 = require("../signature");
const filter_types_1 = require("../../common/filter-types");
class FilterNode extends node_1.default {
    static from(obj) {
        if (obj['type'] === 'filter')
            return new FilterNode(signature_1.ColumnSignature.from(obj['column']), obj['test'], obj['value']);
        return null;
    }
    constructor(column, test, value) {
        super('Filter Node');
        this.column = column;
        this.test = test;
        this.value = value;
    }
    checkPort(portNumber) {
        return portNumber === 0;
    }
    getSignature(datasetRepo) {
        if (!this.incoming[0])
            return null;
        return this.incoming[0].getSignature(datasetRepo);
    }
    validate(datasetRepo, incoming) {
        if (!incoming)
            incoming = this.incoming[0];
        if (!incoming)
            return false;
        // Check that the column is available
        let signature = incoming.getSignature(datasetRepo);
        let valid = signature.containsColumn(this.column);
        // Check that the value is good
        let inTest = this.test === filter_types_1.TestType.In || this.test === filter_types_1.TestType.NotIn;
        let isArray = this.value instanceof Array;
        if (inTest && !isArray)
            valid = false;
        if (!inTest && isArray)
            valid = false;
        return valid && incoming.validate(datasetRepo);
    }
    serialize() {
        return super.serialize({
            type: 'filter',
            column: this.column.serialize(),
            test: this.test,
            value: this.value,
        });
    }
}
exports.default = FilterNode;
